@if (autenticationType == 'login') {
  <button mat-button mat-sm-button color="accent" [routerLink]="['/login']">
    <strong>Se connecter</strong>
  </button>
}
@if (autenticationType == 'signup') {
  <button mat-stroked-button mat-sm-button color="accent" (click)="openDialog()">
    <strong>Abonnez-vous</strong>
  </button>
}
